


import React, { useState, useEffect, useCallback } from 'react';
const API_URL = process.env.REACT_APP_API_URL;
const token = localStorage.getItem('accessToken');

export default function GiftSection({ caseId, sofaResponse }) {
  const [gifts, setGifts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [newGift, setNewGift] = useState({
    person_name: '',
    street1: '',
    street2: '',
    city: '',
    state: '',
    zip_code: '',
    gift_description: '',
    transaction_date: '',
    transaction_value: ''
  });
  const [editGift, setEditGift] = useState(null);

useEffect(() => {
  if (!sofaResponse) return;
  (async () => {
    try {
      const res = await fetch(
        `${API_URL}/cases/${caseId}/sofa-gifts/`, 
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await res.json();
      setGifts(data);
    } catch (err) {
      console.error(err);
    }
  })();
}, [caseId, sofaResponse]);

  const openAdd = () => {
    setNewGift({
      person_name: '',
      street1: '',
      street2: '',
      city: '',
      state: '',
      zip_code: '',
      gift_description: '',
      transaction_date: '',
      transaction_value: ''
    });
    setModalOpen(true);
  };
// import useCallback at top: React, { useState, useEffect, useCallback }
const openEdit = gift => {
  // Pull the single transaction (if any) from the nested array
  const tx = (gift.transactions && gift.transactions[0]) || {};
  setEditGift({
    ...gift,
    transaction_id: tx.id,
    transaction_date: tx.transaction_date || '',
    transaction_value: tx.transaction_value || '',
  });
  setEditModalOpen(true);
};

const saveNew = async () => {
  const res = await fetch(`${API_URL}/cases/${caseId}/sofa-gifts/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(newGift),
  });
  if (res.ok) {
    const created = await res.json();
    // now push the new gift (with its transaction) into state:
    setGifts(prev => [...prev, created]);
    setModalOpen(false);
  } else {
    console.error("Failed to create gift", await res.text());
  }
};

const saveEdit = async () => {
  const res = await fetch(`${API_URL}/cases/${caseId}/sofa-gifts/${editGift.id}/`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(editGift),
  });
  if (!res.ok) {
    console.error('Update failed', await res.text());
    return;
  }
  const updated = await res.json();

  setGifts(prev =>
    prev.map(g => {
      if (g.id === updated.id) {
        return {
          ...updated,
          // override or inject the edited transaction directly
          transactions: [{
            id: editGift.transaction_id,
            transaction_date: editGift.transaction_date,
            transaction_value: editGift.transaction_value
          }]
        };
      }
      return g;
    })
  );
  setEditModalOpen(false);
};

  const deleteGift = async id => {
    await fetch(`${API_URL}/cases/${caseId}/sofa-gifts/${id}/`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` }
    });
    setGifts(prev => prev.filter(g => g.id !== id));
  };

  return (
    <section className="p-6 bg-white shadow-lg rounded mb-6">
      <h2 className="text-xl font-semibold mb-4">Question 13: Gifts</h2>
      <p className="text-sm text-gray-600 mb-4">
            List gifts you have given to someone worth $600 or more in the last 2 years.
        </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-4">
        {gifts.map(g => {
          const tx = g.transactions?.[0] || {};
          return (
            <div
              key={g.id}
              className="p-4 bg-white shadow rounded cursor-pointer hover:shadow-lg transition-shadow relative"
              onClick={() => openEdit(g)}
            >
              <button
                onClick={e => { e.stopPropagation(); deleteGift(g.id); }}
                className="absolute top-2 right-2 text-red-600 hover:text-red-800"
              >
                {/* Trash Icon */}
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" clipRule="evenodd" d="M6 2a1 1 0 00-1 1v1H3a1 1 0 000
                    2h14a1 1 0 000-2h-2V3a1 1 0 00-1-1H6zM4
                    6v10a2 2 0 002 2h8a2 2 0 002-2V6H4zm3
                    2a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0 00-2
                    0zm4 0a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0
                    00-2 0z"/>
                </svg>
              </button>
              <h3 className="font-medium text-lg">{g.person_name}</h3>
              <p className="mt-1 text-sm">{g.street1}{g.street2 ? `, ${g.street2}` : ''}, {g.city}, {g.state} {g.zip_code}</p>
              {tx.transaction_value && (
                <p className="mt-2 text-sm"><strong> Amount:</strong> ${tx.transaction_value}</p>
              )}
              {tx.transaction_date && (
                <p className="mt-1 text-sm"><strong>Date:</strong> {tx.transaction_date}</p>
              )}
            </div>
          );
        })}
      </div>
      <button onClick={openAdd} className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700">
        Add Gift
      </button>

      {/* Add Modal */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Add Gift</h3>
            {/* form fields */}
            {/* Name & Relationship */}
<div className="grid grid-cols-2 gap-4 mb-2">
  <div>
    <label className="block text-sm font-medium mb-1">Name</label>
    <input
      type="text"
      className="w-full border rounded px-2 py-1"
      value={newGift.person_name}
      onChange={e => setNewGift(prev => ({ ...prev, person_name: e.target.value }))}
    />
  </div>
  <div>
    <label className="block text-sm font-medium mb-1">Relationship</label>
    <input
      type="text"
      className="w-full border rounded px-2 py-1"
      value={newGift.relationship}
      onChange={e => setNewGift(prev => ({ ...prev, relationship: e.target.value }))}
    />
  </div>
</div>
{/* Street1 & Street2 */}
<div className="grid grid-cols-2 gap-4 mb-2">
  <div>
    <label className="block text-sm font-medium mb-1">Street 1</label>
    <input
      type="text"
      className="w-full border rounded px-2 py-1"
      value={newGift.street1}
      onChange={e => setNewGift(prev => ({ ...prev, street1: e.target.value }))}
    />
  </div>
  <div>
    <label className="block text-sm font-medium mb-1">Street 2</label>
    <input
      type="text"
      className="w-full border rounded px-2 py-1"
      value={newGift.street2}
      onChange={e => setNewGift(prev => ({ ...prev, street2: e.target.value }))}
    />
  </div>
</div>
{/* City, State, Zip */}
<div className="grid grid-cols-7 gap-4 mb-2">
  <div className="col-span-4">
    <label className="block text-sm font-medium mb-1">City</label>
    <input
      type="text"
      className="w-full border rounded px-2 py-1"
      value={newGift.city}
      onChange={e => setNewGift(prev => ({ ...prev, city: e.target.value }))}
    />
  </div>
  <div className="col-span-1">
    <label className="block text-sm font-medium mb-1">State</label>
    <input
      type="text"
      className="w-full border rounded px-2 py-1"
      value={newGift.state}
      onChange={e => setNewGift(prev => ({ ...prev, state: e.target.value }))}
    />
  </div>
  <div className="col-span-2">
    <label className="block text-sm font-medium mb-1">Zip Code</label>
    <input
      type="text"
      className="w-full border rounded px-2 py-1"
      value={newGift.zip_code}
      onChange={e => setNewGift(prev => ({ ...prev, zip_code: e.target.value }))}
    />
  </div>
</div>
{/* Description */}
<div className="mb-3">
  <label className="block text-sm font-medium mb-1">Description</label>
  <textarea
    className="w-full border rounded px-2 py-1"
    rows="2"
    value={newGift.gift_description}
    onChange={e => setNewGift(prev => ({ ...prev, gift_description: e.target.value }))}
  />
</div>
{/* Value & Date */}
<div className="grid grid-cols-2 gap-4 mb-4">
  <div>
    <label className="block text-sm font-medium mb-1">Value</label>
    <input
      type="number"
      step="0.01"
      className="w-full border rounded px-2 py-1"
      value={newGift.transaction_value}
      onChange={e => setNewGift(prev => ({ ...prev, transaction_value: e.target.value }))}
    />
  </div>
  <div>
    <label className="block text-sm font-medium mb-1">Date</label>
    <input
      type="date"
      className="w-full border rounded px-2 py-1"
      value={newGift.transaction_date}
      onChange={e => setNewGift(prev => ({ ...prev, transaction_date: e.target.value }))}
    />
  </div>
</div>
            <div className="flex justify-end space-x-2">
              <button onClick={()=>setModalOpen(false)} className="px-4 py-2 bg-gray-200 rounded">Cancel</button>
              <button onClick={saveNew} className="px-4 py-2 bg-blue-600 text-white rounded">Save</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {editModalOpen && editGift && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
      <h3 className="text-lg font-semibold mb-4">Edit Gift</h3>
      {/* Name & Relationship */}
      <div className="grid grid-cols-2 gap-4 mb-2">
        <div>
          <label className="block text-sm font-medium mb-1">Name</label>
          <input
            type="text"
            className="w-full border rounded px-2 py-1"
            value={editGift.person_name}
            onChange={e => setEditGift(prev => ({ ...prev, person_name: e.target.value }))}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Relationship</label>
          <input
            type="text"
            className="w-full border rounded px-2 py-1"
            value={editGift.relationship}
            onChange={e => setEditGift(prev => ({ ...prev, relationship: e.target.value }))}
          />
        </div>
      </div>
      {/* Street1 & Street2 */}
      <div className="grid grid-cols-2 gap-4 mb-2">
        <div>
          <label className="block text-sm font-medium mb-1">Street 1</label>
          <input
            type="text"
            className="w-full border rounded px-2 py-1"
            value={editGift.street1}
            onChange={e => setEditGift(prev => ({ ...prev, street1: e.target.value }))}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Street 2</label>
          <input
            type="text"
            className="w-full border rounded px-2 py-1"
            value={editGift.street2}
            onChange={e => setEditGift(prev => ({ ...prev, street2: e.target.value }))}
          />
        </div>
      </div>
      {/* City, State, Zip */}
      <div className="grid grid-cols-7 gap-4 mb-2">
        <div className="col-span-4">
          <label className="block text-sm font-medium mb-1">City</label>
          <input
            type="text"
            className="w-full border rounded px-2 py-1"
            value={editGift.city}
            onChange={e => setEditGift(prev => ({ ...prev, city: e.target.value }))}
          />
        </div>
        <div className="col-span-1">
          <label className="block text-sm font-medium mb-1">State</label>
          <input
            type="text"
            className="w-full border rounded px-2 py-1"
            value={editGift.state}
            onChange={e => setEditGift(prev => ({ ...prev, state: e.target.value }))}
          />
        </div>
        <div className="col-span-2">
          <label className="block text-sm font-medium mb-1">Zip Code</label>
          <input
            type="text"
            className="w-full border rounded px-2 py-1"
            value={editGift.zip_code}
            onChange={e => setEditGift(prev => ({ ...prev, zip_code: e.target.value }))}
          />
        </div>
      </div>
      {/* Description */}
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Description</label>
        <textarea
          className="w-full border rounded px-2 py-1"
          rows="2"
          value={editGift.gift_description}
          onChange={e => setEditGift(prev => ({ ...prev, gift_description: e.target.value }))}
        />
      </div>
      {/* Value & Date */}
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium mb-1">Value</label>
          <input
            type="number"
            step="0.01"
            className="w-full border rounded px-2 py-1"
            value={editGift.transaction_value}
            onChange={e => setEditGift(prev => ({ ...prev, transaction_value: e.target.value }))}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Date</label>
          <input
            type="date"
            className="w-full border rounded px-2 py-1"
            value={editGift.transaction_date}
            onChange={e => setEditGift(prev => ({ ...prev, transaction_date: e.target.value }))}
          />
        </div>
      </div>
      <div className="flex justify-end space-x-2">
        <button onClick={() => setEditModalOpen(false)} className="px-4 py-2 bg-gray-200 rounded">
          Cancel
        </button>
        <button onClick={saveEdit} className="px-4 py-2 bg-blue-600 text-white rounded">
          Save
        </button>
      </div>
    </div>
  </div>
)}
    </section>
  );
}